const MadeiraSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111809)">
      <path
        d="M28.6953 1.98453C26.066 0.713125 23.1162 0 19.9997 0C16.8832 0 13.9335 0.713125 11.3041 1.98453L9.56494 20L11.3041 38.0155C13.9335 39.2869 16.8832 40 19.9997 40C23.1162 40 26.066 39.2869 28.6953 38.0155L30.4345 20L28.6953 1.98453Z"
        fill="#FFDA44"
      />
      <path
        d="M11.3044 1.98535C4.61445 5.22027 0 12.071 0 20.0001C0 27.9293 4.61445 34.78 11.3044 38.0149V1.98535Z"
        fill="#0052B4"
      />
      <path
        d="M28.6958 1.98535V38.0149C35.3856 34.78 40.0002 27.9293 40.0002 20.0001C40.0002 12.071 35.3856 5.22027 28.6958 1.98535Z"
        fill="#0052B4"
      />
      <path
        d="M25.6521 21.7386L26.9564 23.4777V16.5212L25.6521 18.2603H21.7391V14.3473L23.4782 13.043H16.5217L18.2608 14.3473V18.2603H14.3478L13.0435 16.5212V23.4777L14.3478 21.7386H18.2608V25.6516L16.5217 26.9559H23.4782L21.7391 25.6516V21.7386H25.6521Z"
        fill="#D80027"
      />
      <path
        d="M25.2176 19.1311H20.8697V14.7832H19.1306V19.1311H14.7827V20.8702H19.1306V25.218H20.8697V20.8702H25.2176V19.1311Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111809">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MadeiraSvg;
